ISMDSPlugin.define('_',[],function () {
  return ICE._;
});

